// Oktober 2026 · Laden-Sitzung für das Kundendisplay der Kasse (KMG POS).
//
// KMG POS öffnet /buchen?laden=<Schlüssel>. Dieses Modul wird in index.js als
// ERSTES geladen: Es nimmt den Schlüssel aus der Adresse, bevor Router oder
// Tracking sie sehen, und hält ihn nur im Speicher. ensureStoreSession() tauscht
// ihn einmalig gegen ein HttpOnly-Cookie und meldet, ob die Laden-Sitzung aktiv
// ist (dann liefert das Backend den Thekencode für die Thekenzahlung).
import client from "@/lib/api";

let pendingKey = null;
try {
  const url = new URL(window.location.href);
  const key = url.searchParams.get("laden");
  if (key) {
    pendingKey = key;
    url.searchParams.delete("laden");
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
  }
} catch (_) {
  pendingKey = null;
}

let sessionPromise = null;

export function ensureStoreSession() {
  if (!sessionPromise) {
    sessionPromise = (async () => {
      const key = pendingKey;
      pendingKey = null;
      if (key) {
        try {
          await client.post("/store-kiosk/activate", { key });
        } catch (_) {
          // Ungültiger oder fehlender Schlüssel: normale Buchungsseite.
        }
      }
      try {
        const r = await client.get("/store-kiosk/session");
        return r.data?.active ? { active: true, posCode: r.data.pos_code || null } : { active: false };
      } catch (_) {
        return { active: false };
      }
    })();
  }
  return sessionPromise;
}
